export default __webpack_public_path__ + "1e48149915ae7099db2e1e02c627f007.png";